<template>
  <nav class="panel m-t-5">
    <div class="panel-heading is-clearfix">
      {{ $t('form.author') + ': '+ active.author }}

      <div class="is-pulled-right">
        <nuxt-link
          :to="localePath({ name: 'office-reclamations-id-info_id' , params: { info_id: active.id }})"
          class="button is-link is-small m-r-2"
        >
          <i class="mdi mdi-pencil"></i>
        </nuxt-link>
        <button
          @click="removeInfo"
          class="button is-small is-danger"
          :class="{'is-loading': removeInfoLoading}"
        >
          <i class="mdi mdi-trash-can-outline"></i>
        </button>
      </div>
    </div>
    <div class="panel-block">
      <div class="m-t-5" style="width: 100%;">
        <h5 class="subtitle is-5" style="white-space: pre-wrap;">{{active.content}}</h5>
        <div></div>
        <h3 class="title is-3">{{ $t('form.files') }}</h3>
        <form @submit.prevent="onFilesSubmit">
          <div class="is-clearfix">
            <field-file-multiple
              class="is-pulled-left m-t-2 m-r-2"
              required
              name="files"
              :value.sync="files"
              :disabled="uploadFilesLoading !== false"
              :label="$t('form.choose_files')"
            />
            <button
              v-if="files.length"
              class="button is-pulled-left is-primary m-t-2 m-r-2"
              :class="{ 'is-loading': uploadFilesLoading }"
              :disabled="uploadFilesLoading !== false"
            >{{ $t("form.upload") }}</button>
            <button
              v-if="files.length"
              @click="clearFiles"
              :disabled="uploadFilesLoading !== false"
              class="button is-primary m-t-2"
            >{{ $t("form.clear") }}</button>
          </div>
        </form>
        <div class="m-b-3 m-t-5">
          <div v-for="file in active.files" :key="file.id">
            <div class="file">
              <a :href="file.uri" download>{{file.filename}}</a>
              <button
                class="button is-danger is-small m-l-3"
                :class="{'is-loading': removeFileLoading == file.id }"
                @click="removeFile(file.id)"
              >
                <i class="mdi mdi-trash-can-outline"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  props: ['info'],

  data() {
    return {
      removeFileLoading: false,
      uploadFilesLoading: false,
      removeInfoLoading: false,
      files: []
    }
  },

  computed: {
    reclamation() {
      return this.$store.state.reclamations.active;
    },
    active() {
      return this.reclamation.infos.find(e => e.id == this.info.id);
    }
  },

  methods: {
    async removeInfo() {
      if (confirm(this.$t("message.are_you_sure"))) {
        this.removeInfoLoading = true;
        try {
          await this.$api.deleteReclamationInfo(this.info.id);
          await this.$store.dispatch('reclamations/setActiveReclamation', this.reclamation.id);
        } catch (e) {
          console.log(e);
          this.handleFormError(e.response.data);
        } finally {
          this.removeInfoLoading = false;
        }

      }
    },

    async removeFile(file) {
      if (confirm(this.$t("message.are_you_sure"))) {
        this.removeFileLoading = file;
        try {
          await this.$api.deleteReclamationInfoFile(file);
          await this.$store.dispatch('reclamations/setActiveReclamation', this.reclamation.id);
        } catch (e) {
          console.log(e);
          this.handleFormError(e.response.data);
        } finally {
          this.removeFileLoading = false;
        }

      }
    },

    clearFiles() {
      this.files = [];
    },

    async onFilesSubmit() {
      const validation = await this.$validator.validateAll();
      if (!validation) return;

      this.uploadFilesLoading = true;

      const formData = new FormData();

      Array.from(this.files).forEach(e => {
        formData.append("files[]", e, e.name);
      });
      

      try {
        const { data } = await this.$api.uploadReclamationInfoFiles(this.active.id, formData);
        await this.$store.dispatch('reclamations/setActiveReclamation', this.reclamation.id);
        this.clearFiles();
        this.$toast.success(data.message);
      } catch (e) {
        console.log(e);
        this.handleFormError(e.response.data);
      } finally {
        this.uploadFilesLoading = false;
      }

    }
  }
}
</script>

<style lang="scss" scoped>
.file {
  display: inline-block;

  .button {
    opacity: 0;
    pointer-events: none;
  }

  &:hover {
    button {
      opacity: 1;
      pointer-events: all;
    }
  }
}
</style>


// WEBPACK FOOTER //
// resources/nuxt/components/Reclamation/Info.vue